import { render, staticRenderFns } from "./OpenChannelWithNumber.vue?vue&type=template&id=3992f1f0&scoped=true&"
import script from "./OpenChannelWithNumber.vue?vue&type=script&lang=ts&"
export * from "./OpenChannelWithNumber.vue?vue&type=script&lang=ts&"
import style0 from "./OpenChannelWithNumber.vue?vue&type=style&index=0&id=3992f1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992f1f0",
  null
  
)

export default component.exports